import { render, staticRenderFns } from "./googledrive.vue?vue&type=template&id=8fb150ec&scoped=true"
import script from "./googledrive.vue?vue&type=script&lang=js"
export * from "./googledrive.vue?vue&type=script&lang=js"
import style0 from "./googledrive.vue?vue&type=style&index=0&id=8fb150ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb150ec",
  null
  
)

export default component.exports